<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{page.title}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          콘텐츠 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="page.url">{{page.title}}</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchSchoolType label="학교급" :data="data" @search="search" :txt="'txt'" />
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right">
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" @click="openPopup('showNewPopup');" >
            {{page.addName}}
          </b-btn>
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">No</td>
            <template v-if="type=='custContents'">
              <td style="text-align:center" @click="localSort.sort('textbookNm')">과목명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </template>
            <template v-else>
              <td style="text-align:center">이미지</td>
              <td style="text-align:center" @click="localSort.sort('textbookNm')">강좌명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('subjectNm')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </template>
            <td style="text-align:center" >학교급</td>
            <td style="text-align:center" >노출여부</td>
            <td style="text-align:center" @click="localSort.sort('regId')">등록자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('updDt')">수정일(수정자)<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td width="90">자세히보기</td>
          </tr>
          </thead>
          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="7">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index">
            <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
            <template v-if="type=='custContents'">
              <td class="align-middle text-center">{{item.textbookNm}}</td>
            </template>
            <template v-else>
              <td class="align-middle text-center"><img :src="item.thumbnailUrl" width="80"></td>
              <td class="align-middle text-center">{{item.textbookNm}}</td>
              <td class="align-middle text-center">{{getSubjectName(item.subjectCd)}}</td>
            </template>
            <td class="align-middle text-center">
                {{page.getSchoolGradeName(item)}}
            </td>
            <td class="align-middle text-center">{{item.useYn}}</td>
            <td class="align-middle text-center">{{item.regId}}</td>
            <td class="align-middle text-center">
              {{item.updDt}}({{item.updId}})
            </td>
            <td class="align-middle text-center">
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="goDetail(index);"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- Modals -->
    <b-modal size="xl" title="신규과목 등록" v-model="popup.showNewPopup" hide-footer>
      <contentsEditInfo @refresh="search(1);" @close="closePopup('showNewPopup')" 
        :type="type" :bookSeq=0 />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, allSchoolItems, subjectCd1, subjectCd2, subjectCd3, ValueTexts, getSchoolGradeName} from "@/utils/Constants";
import * as textbookApi from "@/api/lm/LmTextBookApi";
import contentsEditInfo from "@/views/contents/contentsEditInfo";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchSchoolType from "../../components/Common/SchSchoolType";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchSchoolType, SchText, ShowCounter, Pagenation, Loading, contentsEditInfo},
    props: {
      type:{
        type:String,
        default:'custContents' // 'custContents':맞춤컨텐츠 관리, 'custClass' : 맞춤강좌 관리
      }
    },
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.schOptions = [];
      const data = reactive(_dataObject);

      const page = reactive({
        bookTypeCd : props.type == 'custContents' ? '330004' : '330005',
        title:'',
        url:'',
        addName:'',
        allSchoolItems:allSchoolItems,
        getSchoolGradeName:(item) => getSchoolGradeName(item)
      });

      const popup = reactive({
        showNewPopup : false
      })

      const retVals = {
        isTest,
        modalLoading,
        page,
        popup,
        data,
        ...methods(props, page, popup, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        retVals.setTitleAndUrl();
        if (store.state.params.name == props.type) {
          const storedData = store.state.params.data;
          retVals.data.params = storedData;
          store.commit('setParams', {name:'', data:undefined});
        } else {
          retVals.reset();
        }
        await retVals.search();
      });
      watch(() => props.type, async (params, oldParams) => {
        console.log(`watch:${oldParams} => ${params}`);
        data.list = [];
        retVals.setTitleAndUrl();
        await retVals.resetSearch();
      });

      return retVals;
    }
}

function methods(props, page, popup, data) {

  function setTitleAndUrl() {
    if (props.type == 'custContents') {
      page.title = '맞춤콘텐츠 관리';
      page.url = '/cs/custContentsList';
      page.addName = '신규과목 추가';
      data.schOptions = [
        {value:'textbookNm', text:'과목명'}
      ];
    } else {
      page.title = '맞춤강좌 관리';
      page.url = '/cs/custClassList';
      page.addName = '신규강좌 추가';
      data.schOptions = [
        {value:'textbookNm', text:'강좌명'}
      ];
    }
  }

  function getSubjectName(subjectCd) {
    const allSubjectCds = [...subjectCd1, ...subjectCd2, ...subjectCd3];
    const subject = allSubjectCds.find((item) => item.value == subjectCd);

    return subject.text;
  }

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:', props, data);

    data.params.page = 1;
    page.allSchoolItems.forEach((item) => {
      data.params[item.key] = null;
    })
    data.params.schType = '';
    data.params.schText = '';

  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    let result = undefined;
    if (props.type == 'custContents') {  // 맞춤 콘텐츠
      data.params.bookTypeCd = '330004';
      result = await textbookApi.getCustContentsList(data.params, this.isTest);
    } else { // 맞춤 강좌
      data.params.bookTypeCd = '330005';
      result = await textbookApi.getCustClassList(data.params, this.isTest);
    }
    
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  // 상세
  function goDetail(index) {
    const item = data.list[index];

    this.$store.commit('setParams', {name:props.type, data:data.params});
    const urlName = props.type == 'custContents' ? 'custContentsDetail' : 'custClassDetail';
    const seq = isNaN(item.bookSeq) ? parseInt(item.bookSeq) : item.bookSeq;
    const info = {
      orgContSeq : item.orgContSeq,
      contSeq : item.contSeq,
    }
    this.$router.push({name:urlName, params:{type:props.type, bookSeq:seq, info:info}});
  }

  // 팝업 열기
  async function openPopup(showPopupKey) {
    popup[showPopupKey] = true;
  }

  // 팝업 닫기
  async function closePopup(showPopupKey) {
    popup[showPopupKey] = false;
  }

  return {
    setTitleAndUrl,
    getSubjectName,
    resetSearch,
    reset,
    search,
    goDetail,
    openPopup,
    closePopup,
  }
}
</script>